module.exports = __webpack_public_path__ + "static/media/BM_ProductQueue.a8ede79c.svg";